import { render, staticRenderFns } from "./Bag.vue?vue&type=template&id=228fb4e3&scoped=true&lang=pug&"
import script from "./Bag.vue?vue&type=script&lang=js&"
export * from "./Bag.vue?vue&type=script&lang=js&"
import style0 from "./Bag.vue?vue&type=style&index=0&id=228fb4e3&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228fb4e3",
  null
  
)

export default component.exports